import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PagedList } from '@app/utils/lists/paged-list/paged-list';
import { StringMap } from '@app/utils/string-map';

@Component({
  selector: 'portal-paged-list-sorter',
  templateUrl: './paged-list-sorter.component.html',
  styles: [],
  standalone: false,
})
export class PagedListSorterComponent implements OnDestroy, OnInit {
  @Input()
  public pagedList!: PagedList<any>;

  /**
   * StringMap property names which values are corresponding translation keys
   */
  @Input()
  public properties!: StringMap<string>;

  public propertyNames: string[];
  public sorting = {};

  private destroyRef = inject(DestroyRef);

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.propertyNames = Object.keys(this.properties);
    this.propertyNames.forEach((propertyName) => (this.sorting[propertyName] = ''));

    this.pagedList.order$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((order) => {
      Object.keys(this.sorting).forEach((key) => {
        this.sorting[key] = '';
      });

      order.forEach(({ key, order }) => {
        if (this.sorting[key as string] != null) {
          this.sorting[key as string] = order;
        }
      });
    });
  }

  public sortBy(propertyName: string) {
    this.changeSortingOf(propertyName);
    if (this.sorting[propertyName] === '') {
      this.pagedList.sortBy([]).draw();
    } else {
      let reverse = this.sorting[propertyName] === 'desc';
      this.pagedList.sortBy(propertyName, reverse).draw();
    }
  }

  private changeSortingOf(propertyName: string) {
    Object.keys(this.sorting).forEach((el) => {
      if (el !== propertyName) {
        this.sorting[el] = '';
      }
    });
    switch (this.sorting[propertyName]) {
      case '':
        this.sorting[propertyName] = 'asc';
        break;
      case 'asc':
        this.sorting[propertyName] = 'desc';
        break;

      default:
        this.sorting[propertyName] = '';
        break;
    }
  }
}
